import React from 'react';
import { Overview } from '@/types';
import { Users, Trophy, Building2, Watch } from '@/utils/icons';
import RetrainReadinessCard from './RetrainReadinessCard';

interface OverviewTabProps {
    overview: Overview | null;
    isDark: boolean;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ overview, isDark }) => (
    <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Total Users Card */}
            <div className={`cgm-metric-card`}>
                <div className="flex items-center gap-3 mb-4">
                    <Users className="w-8 h-8 cgm-icon-data flex-shrink-0" />
                        <div className="text-sm cgm-text-secondary font-medium">Total Users</div>
                </div>
                <div className="text-3xl font-bold cgm-text-primary">{overview?.users?.total || 0}</div>
            </div>

            {/* Total Teams Card */}
            <div className={`cgm-metric-card`}>
                <div className="flex items-center gap-3 mb-4">
                    <Trophy className="w-8 h-8 cgm-icon-success flex-shrink-0" />
                        <div className="text-sm cgm-text-secondary font-medium">Total Teams</div>
                </div>
                <div className="text-3xl font-bold cgm-text-primary">{overview?.teams?.total || 0}</div>
            </div>

            {/* Total Organizations Card */}
            <div className={`cgm-metric-card`}>
                <div className="flex items-center gap-3 mb-4">
                    <Building2 className="w-8 h-8 cgm-icon-neutral flex-shrink-0" />
                        <div className="text-sm cgm-text-secondary font-medium">Organizations</div>
                </div>
                <div className="text-3xl font-bold cgm-text-primary">{overview?.organizations?.total || 0}</div>
            </div>

            {/* Connected Devices Card */}
            <div className={`cgm-metric-card`}>
                <div className="flex items-center gap-3 mb-4">
                    <Watch className="w-8 h-8 cgm-icon-activity flex-shrink-0" />
                        <div className="text-sm cgm-text-secondary font-medium">Connected Devices</div>
                </div>
                <div className="text-3xl font-bold cgm-text-primary">{overview?.users?.whoop_connected || 0}</div>
            </div>
        </div>

        <RetrainReadinessCard />
    </div>
);

export default OverviewTab;
